import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import {
  Body,
  Button,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Separator,
} from '@e2n/ui/v2';
import {
  faCircle,
  faCircleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

export function KonfliktIndicator({
  konfliktStationen,
}: {
  konfliktStationen: ArbeitsbereichStation[];
}) {
  const { t } = useTranslation();

  if (konfliktStationen.length === 0) {
    return null;
  }

  const label = t(
    'domain.mitarbeiter.rotationsplan.rotationsplaene.konflikt.count',
    { count: konfliktStationen.length },
  );

  const konfliktList = konfliktStationen.map((station, index) => (
    <Fragment key={station.id}>
      <div className="flex items-center justify-between gap-6">
        <div className="flex items-center min-w-0 gap-2">
          <FontAwesomeIcon
            className="size-2.5"
            icon={faCircle}
            color={station.arbeitsbereich.getBorderColor()}
          />
          <Body className="truncate">{station.arbeitsbereich.name}</Body>
        </div>
        <Body className="whitespace-nowrap">
          {dayjs(station.von).format('DD.MM') +
            ' - ' +
            dayjs(station.bis).format('DD.MM.YYYY')}
        </Body>
      </div>
      {index < konfliktStationen.length - 1 && <Separator />}
    </Fragment>
  ));

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="small" aria-label={label}>
          <FontAwesomeIcon
            className="size-3.5 text-error-red-200"
            icon={faCircleExclamation}
          />
          <Body className="ml-1" size="sm">
            {label}
          </Body>
        </Button>
      </PopoverTrigger>
      <PopoverContent
        side="right"
        align="center"
        className="gap-2 px-4 py-3 md:min-w-75">
        <Body weight="semibold">
          {t('domain.mitarbeiter.rotationsplan.rotationsplaene.konflikt.title')}
        </Body>
        {konfliktList}
      </PopoverContent>
    </Popover>
  );
}
